import React from 'react';
import { Notice, TextInput } from '@origo/origo-ui';
import type { PreflightRequest } from '../../../api/types';
import styles from './create.module.css';

interface CreateServiceStepProps {
    request: PreflightRequest;
    onChange: (patch: Partial<PreflightRequest>) => void;
    /** Vises hvis forrige preflight (utløst av «Videre») feilet. */
    preflightError: string | null;
}

/**
 * Steg 1: tjeneste-detaljer. Preflight kjøres automatisk når brukeren går videre, og gir
 * forslaget til felt-mapping som vises i neste steg.
 */
export const CreateServiceStep: React.FC<CreateServiceStepProps> = ({
    request,
    onChange,
    preflightError,
}) => {
    return (
        <div className={styles.single}>
            <div className={styles.fieldGroup}>
                <p className={styles.sectionHeading}>Tjeneste</p>
                <p className={styles.intro}>
                    En kobling synkroniserer ett AGOL feature-service mot et sentralt datasett.
                    Når du går videre inspiserer vi tjenesten og foreslår hvordan feltene mappes
                    mot det sentrale skjemaet — forslaget kan du se over og rette i neste steg.
                </p>
                <TextInput
                    label="Forvaltningssystem"
                    placeholder="ngis"
                    value={request.forvaltningssystem}
                    onChange={(e) => onChange({ forvaltningssystem: e.target.value })}
                />
                <TextInput
                    label="Sentralt datasett-ID"
                    placeholder="UUID for datasettet i forvaltningssystemet"
                    value={request.centralDatasetId}
                    onChange={(e) => onChange({ centralDatasetId: e.target.value })}
                />
                <TextInput
                    label="AGOL feature-service URL"
                    placeholder="https://services.arcgis.com/…/FeatureServer"
                    helperText="Peker på feature-service-URLen (uten lag-ID)."
                    value={request.agolBaseUrl}
                    onChange={(e) => onChange({ agolBaseUrl: e.target.value })}
                />
            </div>

            {preflightError && <Notice variant="danger">{preflightError}</Notice>}
        </div>
    );
};
